import { createApp } from '@/api/advertiser'
import { getKvData } from '@/api/open'

export default {
    components: {},
    props: {
        showAppForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
        version_type: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
            roles: [],
            corporations: [],
            loading: false,
            rules: {
                miniapp_name: [{ required: true, message: '请输入小程序名称', trigger: 'change' }],
                miniapp_username: [{ required: true, message: '请输入小程序原始ID', trigger: 'change' }],
                type: [{ required: true, message: '请输入小程序类型', trigger: 'change' }],
                link_remark: [{ required: true, message: '请输入链接备注', trigger: 'change' }],
                tag_info: [{ required: true, message: '请选择小程序类目', trigger: 'change' }],
                version_type: [{ required: true, message: '请选择工作台类型', trigger: 'change' }],
            },
            workers: [],
            admins: [],
            showCreateAppResult: true,
            result: {
                success: [],
                errors: [],
            },
            types: [
                {id: 14, name: '常读-杞岱剧场-字节小程序'},
                // {id: 1, name: '常读-微信小程序'},
                {id: 11, name: '常读-怅栗好看-微信小程序'},
                {id: 15, name: '常读-堂卷好看-微信小程序'},
                {id: 2, name: '常读-每日剧场-字节小程序'},
                {id: 7, name: '常读-沁黛剧场-字节小程序'},
                {id: 3, name: '常读-常读制剧-字节小程序'},
                {id: 4, name: '点众-微信小程序'},
                {id: 5, name: '点众-字节小程序'},
                {id: 6, name: '海狮剧场-点众-字节小程序'},
                {id: 12, name: '雪蘅剧场-点众-字节小程序(IAA)'},
                {id: 13, name: '秘境短剧-点众-字节小程序(IAP)'},
                {id: 8, name: '源寒短剧-掌阅-微信小程序'},
                {id: 9, name: '苍翠微剧-掌阅-字节小程序'},
                {id: 10, name: '凯猫好剧-七猫-字节小程序'},
            ],
            navs: [],
            xcxNavs: [],
        }
    },
    computed: {
        actType() {}
    },
    mounted() {
        if (this.version_type) {
            this.$set(this.model, 'version_type', this.version_type)
        } else {
            this.$set(this.model, 'version_type', 1)
        }
        // console.log('this.model', this.model)

        //此处开始获取类目
        getKvData({type:3}).then(res => {
            this.navs = res.data || []
            this.getXcxNavs()
        })

        // console.log('进入', this.model)
        if (!this.model.miniapp_name && !this.model.miniapp_username) { 
            //没有默认值，给与默认值
            this.changeType(11)
        }
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.createApp()
            })
        },
        createApp() {
            this.result.success = []
            this.result.errors = []
            this.loading = true
            const json = {
                ids: this.model.id > 0 ? [this.model.id] : this.model.ids,
                miniapp_name: this.model.miniapp_name,
                miniapp_username: this.model.miniapp_username,
                playlet_gender: this.model.playlet_gender,
                type: this.model.type,
                link_remark: this.model.link_remark,
                tag_info: this.model.tag_info[1],
                version_type: this.model.version_type,
            }
            // console.log('json', json)
            createApp(json).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.result = res.data
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showAppForm', false)
            this.$emit('success')
        },
        changeType(flag) {
            // let xcxType = this.model.type
            // if (this.model.type === 1) {
            //     // TODO --点兰剧场不用了
            //     this.model.miniapp_name = '点兰剧场'
            //     this.model.miniapp_username = 'gh_33d0278b21f6'
            // } else 
            if (this.model.type === 2) {
                this.model.miniapp_username = 'tt9c36ea8b0305b6c401'
                this.model.miniapp_name = '每日剧场'
            } else if (this.model.type === 7) {
                this.model.miniapp_username = 'tt4a2f3c92d51b1b2e01'
                this.model.miniapp_name = '沁黛剧场'
            } else if (this.model.type === 14) {
                this.model.miniapp_username = 'tt0b847d3994b05ad101'
                this.model.miniapp_name = '杞岱剧场'
            } else if (this.model.type === 3) {
                this.model.miniapp_username = 'ttf3bc85016c8a4e7001'
                this.model.miniapp_name = '常读制剧'
            }  else if (this.model.type === 4) {
                //点众-微信
                this.model.miniapp_username = 'gh_e979f24d478c'
                this.model.miniapp_name = '青稞短剧'
            }  else if (this.model.type === 5) {
                //点众-字节
                this.model.miniapp_username = 'tt915ce7e10e62aad901'
                this.model.miniapp_name = '宝藏剧场'
            } else if (this.model.type === 6) {
                //海狮剧场-点众-字节
                this.model.miniapp_username = 'ttaa72dccf3544da4701'
                this.model.miniapp_name = '海狮剧场'
            } else if (this.model.type === 12) {
                //雪蘅剧场-点众-字节(IAA)
                this.model.miniapp_username = 'ttaf0ed9b330067c4501'
                this.model.miniapp_name = '雪蘅剧场'
            } else if (this.model.type === 13) {
                //秘境短剧-点众-字节(IAP)
                this.model.miniapp_username = 'tt726104dced6a3eb501'
                this.model.miniapp_name = '秘境短剧'
            } else if (this.model.type === 8) {
                //源寒短剧-掌阅 微小
                this.model.miniapp_username = 'gh_8fb81d8e2bcd'
                this.model.miniapp_name = '源寒短剧'
            } else if (this.model.type === 9) {
                //苍翠微剧-掌阅 抖小
                this.model.miniapp_username = 'tt2f7c59c1b04cbb7801'
                this.model.miniapp_name = '苍翠微剧'
            } else if (this.model.type === 10) {
                //凯猫好剧-七猫 抖小
                this.model.miniapp_username = 'tt6caa1a17f39ddb5b01'
                this.model.miniapp_name = '凯猫好剧'
            } else if (this.model.type === 11) {
                //常读-怅栗好看-微小
                this.model.miniapp_name = '怅栗好看'
                this.model.miniapp_username = 'gh_10e4959aab23'
            } else if (this.model.type === 15) {
                //常读-堂卷好看-微小
                this.model.miniapp_name = '堂卷好看'
                this.model.miniapp_username = 'gh_4aeba2680d40'
            } 

            this.model.playlet_gender = null
            this.model.tag_info = null
            if (flag != 1) {
                this.getXcxNavs()
            }
        },
        findCategoriesByName(data, categoryName) {
            for (let category of data) {
              if (category.category_name === categoryName) {
                return category.categories || [];
              }
              if (category.categories) {
                const result = this.findCategoriesByName(category.categories, categoryName);
                if (result.length) {
                  return result;
                }
              }
            }
            return []; // 如果没有找到，返回空数组
        },
        getXcxNavs() {
            this.xcxNavs = []
            let navs = []
            //需要获取类目: 2,3,5是字节小程序
            if ([2,3,5,6,7,9,10,12,13,14].includes(this.model.type)) {
                navs = this.navs.dy.categories
            } else {
                navs = this.navs.wx.categories
            }

            navs = this.findCategoriesByName(navs, '短剧')


            navs.forEach(element => {
                let categories = []
                element.categories.forEach(element2 => {
                    categories.push({
                        value: element2.category_id,
                        label: element2.category_name,
                    })
                })

                let item = {
                                "value": element.category_name,
                                "label": element.category_name,
                                "disabled": false,
                                "children": categories
                            }
                this.xcxNavs.push(item)
            });
            // console.log('navs', this.xcxNavs)
        },
    }
}
